import { Link } from 'gatsby';
import { AnchorHTMLAttributes } from 'react';
import styled, { css } from 'styled-components';

interface ClickableContainerProps {
  $disabled?: boolean;
  $bypass?: boolean;
  $display?: 'inline-block' | 'block' | 'flex';
}

const disabledStyles = css`
  cursor: not-allowed;
  pointer-events: none;
  opacity: 0.6;
`;

const clickableStyles = css<ClickableContainerProps>`
  cursor: pointer;
  text-decoration: none;
  display: ${({ $display }) => $display || 'inline-block'};
  transition: opacity 200ms ease-in-out;
  outline: none;
  color: inherit;
  overflow: visible;

  ${({ $bypass }) =>
    $bypass &&
    css`
      cursor: default;
    `}

  ${({ $disabled }) => $disabled && disabledStyles}
`;

export const ClickableContainer = styled.div<ClickableContainerProps>`
  ${clickableStyles}
`;

export const InternalLinkContainer = styled(Link)<ClickableContainerProps>`
  ${clickableStyles}
`;

type ExternalLinkContainerProps = ClickableContainerProps & AnchorHTMLAttributes<HTMLAnchorElement>;

export const ExternalLinkContainer = styled.a<ExternalLinkContainerProps>`
  ${clickableStyles}
`;
